export const chooseColor = (diffType) => {
    switch (diffType) {
        case "replace":
            return {fill: "rgba(35,134,238, 0.2)", stroke: "rgba(35,134,238, 1.0)", active: "rgba(35,134,238, 0.5)"}
        case "delete":
            return {fill: "rgba(253,194,0, 0.2)", stroke: "rgba(253,194,0, 1.0)", active: "rgba(253,194,0, 0.5)"}
        case "insert":
            return {fill: "rgba(27,168,84, 0.2)", stroke: "rgba(27,168,84, 1.0)", active: "rgba(27,168,84, 0.5)"}
        default:
            return {}
    }
}
